import React from 'react';

import betaImage from '../images/beta2-30.png';

export function BetaIcon() {
  return <img src={betaImage} />;
}
